import { render, staticRenderFns } from "./AxAppFailureDb.vue?vue&type=template&id=f44608ee&scoped=true&"
import script from "./AxAppFailureDb.vue?vue&type=script&lang=ts&"
export * from "./AxAppFailureDb.vue?vue&type=script&lang=ts&"
import style0 from "./AxAppFailureDb.vue?vue&type=style&index=0&id=f44608ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44608ee",
  null
  
)

export default component.exports